import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import ListPrice from '../ListPrice/ListPrice';
import Currency from '../Currency/Currency';

const ProductPrice = (props) => {
  const {
    className,
    context,
    isEMEA,
    isCallForPrice,
    listPrice,
    price,
    vatPrice,
    showListPrice,
  } = props;

  const currencyCode = props.currencyCode || (context && context.currencyCode);
  return (
    <div className={cn('c-product-price', className)}>
      {!isCallForPrice && showListPrice && (
        <ListPrice
          currencyCode={currencyCode}
          listPrice={listPrice}
          insightPrice={price}
          showVAT={isEMEA}
          tax={false}
          strike
          valueClassName="u-clearfix"
        />
      )}
      {!isCallForPrice && (
        <Currency
          className="u-clearfix"
          currencyCode={currencyCode}
          value={price}
          showVAT={isEMEA}
          highlight={isEMEA}
          tax={false}
        />
      )}
      {isEMEA && vatPrice != null && (
        <div>
          <Currency
            currencyCode={currencyCode}
            value={vatPrice}
            showVAT={isEMEA}
            tax
          />
        </div>
      )}
    </div>
  );
};

export default ProductPrice;

ProductPrice.propTypes = {
  className: PropTypes.string,
  context: PropTypes.shape({
    currencyCode: PropTypes.string,
    locale: PropTypes.string,
  }).isRequired,
  currencyCode: PropTypes.string,
  isCallForPrice: PropTypes.bool,
  isEMEA: PropTypes.bool,
  listPrice: PropTypes.string, // test for price difference with price
  vatPrice: PropTypes.string,
  price: PropTypes.string.isRequired,
  showListPrice: PropTypes.bool,
};

ProductPrice.defaultProps = {
  className: '',
  currencyCode: undefined,
  isCallForPrice: false,
  isEMEA: false,
  listPrice: undefined,
  vatPrice: undefined,
  showListPrice: true,
};
